module.exports = __webpack_public_path__ + "static/media/now-frozen-mb-fr.2b2ea2cb.jpg";